import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage, faRotateRight, faTrash } from "@fortawesome/pro-regular-svg-icons";
import "./emailBuilderBackgroundImageField.scss";

type EmailBuilderSettingsImagePickerProps = {
  previewUrl?: string;
  chooseLabel?: string;
  replaceLabel?: string;
  onOpen: () => void;
  onRemove?: () => void;
};

export function EmailBuilderSettingsImagePicker({
  previewUrl,
  chooseLabel,
  replaceLabel,
  onOpen,
  onRemove,
}: EmailBuilderSettingsImagePickerProps) {
  const { t } = useTranslation();
  const hasImage = Boolean(previewUrl && previewUrl.trim().length > 0);
  const resolvedChooseLabel = chooseLabel ?? t("Choose an image");
  const resolvedReplaceLabel = replaceLabel ?? t("Replace");

  return (
    <div className="email-builder-settings-background-image">
      <div className="email-builder-settings-background-image__label">{t("Image")}</div>
      {hasImage ? (
        <div className="email-builder-settings-background-image__selected">
          <div className="email-builder-settings-background-image__preview" aria-hidden="true">
            <img src={previewUrl} alt="" />
          </div>
          <div className="email-builder-settings-background-image__actions">
            <button
              type="button"
              className="email-builder-settings-background-image__action-btn"
              onClick={onOpen}
            >
              <FontAwesomeIcon icon={faRotateRight} aria-hidden="true" />
              {resolvedReplaceLabel}
            </button>
            {onRemove ? (
              <button
                type="button"
                className="email-builder-settings-background-image__remove-btn"
                onClick={onRemove}
              >
                <FontAwesomeIcon icon={faTrash} aria-hidden="true" />
                {t("Remove")}
              </button>
            ) : null}
          </div>
        </div>
      ) : (
        <button
          type="button"
          className="email-builder-settings-background-image__choose-btn"
          onClick={onOpen}
        >
          <FontAwesomeIcon icon={faImage} aria-hidden="true" />
          {resolvedChooseLabel}
        </button>
      )}
    </div>
  );
}
